import { checkAllScopes } from "@src/components/LimitAccess/check-scopes";
import { useBooleanWebUiScopeMap } from "@src/components/LimitAccess/check-scopes-hooks";

export const useCanCreateCustomEvent = () => {
  const scopeMap = useBooleanWebUiScopeMap();

  return checkAllScopes([scopeMap["create_custom_event"]]);
};
